import { render, staticRenderFns } from "./QACard.vue?vue&type=template&id=038740e2&scoped=true&"
import script from "./QACard.vue?vue&type=script&lang=js&"
export * from "./QACard.vue?vue&type=script&lang=js&"
import style0 from "./QACard.vue?vue&type=style&index=0&id=038740e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038740e2",
  null
  
)

export default component.exports